$( window ).on("load", function() {
  //alert("gg");

    if($(".globo-form-app .globo-form-control").length){
      //alert("Load globo-form-app");

        setTimeout(function(){
            $('.customer-information-block').wrapAll('<div class="customer-information-section left-block" />');
            $('.customer-contact-way-block').wrapAll('<div class="customer-information-section right-block" />');          
        },2000);      


        setTimeout(function(){
            $('.customer-information-section').wrapAll('<div class="customer-information-main-section" />');
        },3000);              

        setTimeout(function(){
            $('.shipping-information-block').wrapAll('<div class="shipping-information-section shipping-information-inner-section" />');
            $('.request-details-block').wrapAll('<div class="request-details-section shipping-information-inner-section" />');
            
            $('.shipping-information-inner-section').wrapAll('<div class="shipping-information-main-section left-block" />');
            $('.product-details-block').wrapAll('<div class="shipping-information-main-section right-block" />');          
        },2000);   
        
        setTimeout(function(){
            $('.shipping-information-main-section').wrapAll('<div class="shipping-product-information-main-section" />');

            $(".bulk-order-form-product-inner-section .globo-form-app .gfb__footer.wizard__footer button.reset").click(function(){
              //alert("Bulk Order open");
              $("body").removeClass("bulk_order_is_open");
              $('html, body').animate({
                  scrollTop: 0
              }, 800);              
            });  

        },3000);           
        
    }  

   
});


$(document).ready(function(){
  $(".request_bulk_order_btn").click(function(){
    //alert("Bulk Order open");
    $("body").addClass("bulk_order_is_open");
  });





});